import { cn } from '@/lib/utils';

import { FAQ_DATA, type FaqEntry } from '../../constants/landing-constants';
import { FAQItem } from '../common/faq-item';

type FAQSectionProps = {
	faqData?: FaqEntry[];
	title?: string;
	headingClassName?: string;
	/**
	 * Alignment of the heading and items. Defaults to centered. `left` is the
	 * article layout (best-free-ats): left-aligned text inside the same centred
	 * max-w-3xl column as the page's other sections.
	 */
	align?: 'center' | 'left';
};

export const FAQSection = ({
	faqData = FAQ_DATA,
	title = 'Questions?',
	headingClassName,
	align = 'center',
}: FAQSectionProps) => {
	const isLeft = align === 'left';

	return (
		<section
			className={cn('landing-width mb-24 w-full px-4 md:mb-32 md:px-8', !isLeft && 'md:mb-40')}
		>
			<div className={cn('mx-auto', isLeft && 'max-w-3xl')}>
				<div className={cn('mb-8 md:mb-12', isLeft ? 'text-left' : 'text-center')}>
					<h2 className={cn('landing-heading', headingClassName)}>{title}</h2>
				</div>

				<div className={cn(!isLeft && 'mx-auto max-w-2xl')}>
					{faqData.map((faq, index) => (
						<FAQItem
							key={index}
							question={faq.question}
							answer={faq.answer}
							link={faq.link}
							isLast={index === faqData.length - 1 || Boolean(faqData[index + 1]?.isStatic)}
							isStatic={faq.isStatic}
						/>
					))}
				</div>
			</div>
		</section>
	);
};
